// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"484":"d52227eb","557":"180b40d5","945":"180b40d5"}[chunkId] + ".chunk.css";
};